export default __webpack_public_path__ + "static/media/SanjayShah.222c2de0.jpg";